import { render, staticRenderFns } from "./SetupViessmannMeasurementsWizardControl.global.vue?vue&type=template&id=1cdd246a&lang=pug&"
import script from "./SetupViessmannMeasurementsWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./SetupViessmannMeasurementsWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports